import axios from "axios";
import { getValues } from "./storage";

const userLoggedIn = getValues("loggedIn");
export const username = getValues("username");

export const BASE_URL = `${process.env.REACT_APP_PRODUCTION_BASE_URL}`; //PRODUCTION_URL
// export const BASE_URL = `${process.env.REACT_APP_PRODUCTION_BASE_URL_TEST}` //TEST_URL
export const BASE_URL_OTP = process.env.REACT_APP_OTP_BASE_URL;
export const BASE_POCKET_URL = process.env.REACT_APP_POCKET_BASE_URL;
export const BASE_URL_PROD_POCKET = process.env.REACT_APP_PROD_POCKET_BASE_URL;
export const STAGING_BASE_URL = process.env.REACT_APP_POCKET_STAGING_BASE_URL;

// export const BASE_URL = `${process.env.REACT_APP_STAGING_BASE_URL}` //STAGING_URL

// export const PUBLIC_KEY = getValues(`${username}_public_key`)

// const axiosRequest = (reqMethod) => {
//     try{
//         // const res = axios.reqMethod(url, data)
//     }
// }

const headers = {
  "Content-Type": "application/json",
  // "Authorization": `Bearer ${token}`,
};

export const getRequest = async (url, headers) => {
  const res = await axios.get(url, headers);
  return res;
};

export const postRequest = async (url, postData, headers) => {
  const res = await axios.post(url, postData, headers);
  return res;
};

export const deleteRequest = async (url, postData, headers) => {};

export enum ResponseStatusEnum {
  ERROR = "error",
  SUCCESS = "success",
  FAIL = "failed",
  DUPLICATE_REFERENCE = "duplicate_reference",
  INVALID_PIN = "invalid_pin",
  PENDING = "pending",
  NEW_DEVICE = "new_device",
}
